import { useTranslation } from 'react-i18next';
import { commonDescendingComparator, getUserPreferredFullName } from 'utils/helper';

export const useTableColumns = () => {
    const { t } = useTranslation();

    return [
        {
            id: 'student-name',
            columnTitle: t('table.student-name', 'Student Name'),
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => {
                    return getUserPreferredFullName(item).toLowerCase();
                };

                if (order === 'desc') {
                    const sortedSubmissions = [...items].sort((a, b) => commonDescendingComparator(a, b, getter));
                    return sortedSubmissions;
                }
                const sortedSubmissions = [...items].sort((a, b) => -commonDescendingComparator(a, b, getter));
                return sortedSubmissions;
            },
        },
        {
            id: 'drafts-submitted',
            columnTitle: t('table.drafts-submitted', 'Drafts Submitted'),
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => {
                    return item.submissions.length;
                };

                if (order === 'desc') {
                    const sortedSubmissions = [...items].sort((a, b) => commonDescendingComparator(a, b, getter));
                    return sortedSubmissions;
                }
                const sortedSubmissions = [...items].sort((a, b) => -commonDescendingComparator(a, b, getter));
                return sortedSubmissions;
            },
        },
    ];
};
